import React from 'react'
import Footer from '../components/Footer'
import ContactForm from '../components/ContactForm'

const Contact = () => {
  return (
    <div>
        <ContactForm />
        <Footer />
    </div>
  )
}

export default Contact